import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/workspace/src/layouts/blogPost.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Today we’re excited to announce that the Arbitrum network is `}<a parentName="p" {...{
        "href": "https://arbitrum.io/"
      }}>{`open to the public`}</a>{` — users can now trade on the Arbitrum deployment of Starswap v3 with low gas costs and instant transaction confirmations!`}</p>
    <p>{`As DeFi adoption continues to ramp up, bringing scalability to Ethereum has become more necessary than ever. Thankfully, Layer 2 solutions like Arbitrum have the potential to provide additional bandwidth without sacrificing the ideals of decentralization and security that we value so highly. `}</p>
    <p>{`During this initial launch, Arbitrum will support throughput of 80k arb gas per second, which should translate to transaction capacity roughly in line with Layer 1. Unlike L1, transactions on Arbitrum confirm instantly — no more pending or stuck swaps!`}</p>
    <h1 {...{
      "id": "launch-details",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#launch-details",
        "aria-label": "launch details permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Launch Details`}</h1>
    <p>{`Users can start migrating assets over to the Arbitrum network through the `}<a parentName="p" {...{
        "href": "https://bridge.arbitrum.io/"
      }}>{`Arbitrum Bridge`}</a>{` by following this `}<a parentName="p" {...{
        "href": "https://help.starswap.xyz/en/articles/5538618-how-to-deposit-tokens-to-arbitrum"
      }}>{`user guide`}</a>{`. Arbitrum is immediately compatible with popular wallets (Metamask, WalletConnect), as well as analytics services, `}<a parentName="p" {...{
        "href": "https://arbiscan.io/"
      }}>{`Arbiscan`}</a>{` and The Graph. Starswap Protocol activity on Arbitrum can be tracked at `}<a parentName="p" {...{
        "href": "info.starswap.xyz/#/arbitrum"
      }}>{`info.starswap.xyz/#/arbitrum`}</a>{`. `}</p>
    <p>{`Please treat this as an early alpha product! As a new piece of software, the Arbitrum network is still in need of rigorous battletesting, as Offchain Labs has `}<a parentName="p" {...{
        "href": "https://offchain.medium.com/mainnet-for-everyone-27ce0f67c85e"
      }}>{`noted`}</a>{`. At launch, the Arbitrum team will have upgrade rights over the bridge contract, allowing them to address any issues that may arise. While fraud proofs are up and running, at the outset there is a whitelist of validators who may submit proofs. `}</p>
    <p>{`A few additional Alpha launch features to be aware of: `}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Downtime`}</strong>{`: The Arbitrum team does not have any planned downtime, but it is possible that the network encounters unplanned outages as usage increases and the protocol stabilizes. In the event of an unplanned outage, transactions will cease to be confirmed and Starswap Protocol LPs will not earn trading fees to compensate for their price exposure. `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Withdrawal times`}</strong>{`: Deposits from Ethereum L1 to the Arbitrum network will take as long as a standard Ethereum transaction, while withdrawals will take 7 days in order to account for the challenge period. However, for select assets and a minor fee, users can opt for fast exits using third party services like Hop Protocol.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Available assets`}</strong>{`: At launch, the Arbitrum network supports `}<a parentName="p" {...{
            "href": "https://bridge.arbitrum.io/token-list-42161.json"
          }}>{`33 assets`}</a>{`, including USDC, WETH, and WBTC. Additional tokens will be added to the network on an ongoing basis.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`TWAP Oracles`}</strong>{`: The Arbitrum sequencer introduces an additional trust assumption for developers using v3 price feeds. More information on the Arbitrum sequencer can be `}<a parentName="p" {...{
            "href": "https://developer.offchainlabs.com/docs/inside_arbitrum#sequencer-mode"
          }}>{`found here`}</a>{`. `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Composability`}</strong>{`: Arbitrum supports full composability. As of today, anyone can deploy a smart contract to Arbitrum mainnet! A list of Arbitrum ecosystem projects can be `}<a parentName="p" {...{
            "href": "https://portal.arbitrum.one/"
          }}>{`found here`}</a>{`. `}</p>
      </li>
    </ul>
    <p>{`While these are still relatively early days and scaling will be an iterative process, we’ve never been more confident that the industry is moving in the right direction!   `}</p>
    <hr></hr>
    <p>{`To get involved and stay up to date:`}</p>
    <ul>
      <li parentName="ul">{`Join the Starswap community `}<a parentName="li" {...{
          "href": "https://discord.com/invite/FCfyBSbCU5"
        }}>{`discord`}</a></li>
      <li parentName="ul">{`Follow Starswap Labs on `}<a parentName="li" {...{
          "href": "/Starswap"
        }}>{`Twitter`}</a></li>
      <li parentName="ul">{`Subscribe to the Starswap Labs `}<a parentName="li" {...{
          "href": "https://starswap.xyz/rss.xml"
        }}>{`blog`}</a></li>
      <li parentName="ul">{`Register as a delegate on `}<a parentName="li" {...{
          "href": "https://sybil.org/#/delegates/Starswap"
        }}>{`Sybil`}</a></li>
      <li parentName="ul">{`Participate in Starswap `}<a parentName="li" {...{
          "href": "https://gov.starswap.xyz/"
        }}>{`governance`}</a></li>
    </ul>
    <p>{`Starswap Team
🦄`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      